import React from "react"

class HousekeepingTypeDataType extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.row.housekeeping_status == "disabled") {
      return (
        <div>
          {I18n.t('Disabled')}
        </div>
      )
    }
    if (this.props.row.housekeeping_status == "enabled") {
      return (
        <div>
          {I18n.t('Enabled')}
        </div>
      )
    }
    if (this.props.row && this.props.row.type && this.props.row.type.housekeeping_type && this.props.row.type.housekeeping_type.frequency ) {
      housekeeping_types = this.props.row.type.housekeeping_type.map((housekeeping_type, idx) => {
        return <li key={idx}>{housekeeping_type.code}: {I18n.t(housekeeping_type.frequency)}</li>
      })
      return (
        <ul style={{ marginBottom: 0 }}>{housekeeping_types}</ul>
      );
    } else if (this.props.row && this.props.row.type && this.props.row.type.housekeeping_type) {
      return <div>{this.props.row.type.housekeeping_type.code}</div>
    } else {
      return (
        <div>
          <span className="none">{I18n.t('none')}</span>
        </div>
      )
    }
  }

};

export default HousekeepingTypeDataType